import { createStore } from 'vuex'
import axios from "axios";
import user from "./modules/user";
import auth from "./modules/auth";
import administration from "./modules/administration";
import test from './test.json';

const debug = process.env.NODE_ENV !== 'production'

const fetchApi = {
  state: {
    repository: []
  },
  mutations: {
    fetching(state, { repository }) {
      state.repository = repository
    }
  },
  actions: {
    LOAD_LISTREPOSITORY: async function (context) {
      axios.get(process.env.VUE_APP_API + '?endpoint=repository%2Flistrepository')
        .then((response) => {
          context.commit('fetching', { repository: response.data })
          return true;
        }, (err) => {
          console.log(err)
          return false;
        })
    }
  },
  getters: {
    allRepository: (state) => state.repository
  }
}

export default createStore({
  state: {
    markText: '',
    test: test,
  },
  mutations: {
    addGraph(state, data){
      // Correction ici : utiliser state.fetchApi.repository
      state.fetchApi.repository.push(data)
    },
    removeGraphById(state, index){
      // Correction ici : utiliser state.fetchApi.repository
      state.fetchApi.repository.splice(index, 1)
    },
  },
  actions: {
    addGraph(context, data){
      context.commit('addGraph', data)
    },
    removeGraphById(context, id){
      id = parseInt(id)
      // Correction ici : utiliser state.fetchApi.repository
      const index = context.state.fetchApi.repository.findIndex((post) => { return post.id == id })
      context.commit('removeGraphById', index)
    },
  },
  modules: {
    fetchApi,
    auth,
    administration,
    user
  },
  strict: debug,
})
